import { type FC } from 'react';
import cn from 'classnames';
import styles from './ReservedSampleStatusChip.module.scss';
import { capitalise } from './SampleNames.utils';
import { type ReservedSample } from './SampleNames.model';

interface ReservedSampleStatusChipProps {
  status: ReservedSample['status'];
}

const ReservedSampleStatusChip: FC<ReservedSampleStatusChipProps> = ({ status }) => (
  <span className={cn(styles.chip, styles[status])}>{capitalise(status)}</span>
);

export default ReservedSampleStatusChip;
